import { sdkApi } from '../api';
import TCClient from 'client';
import { SearchTypes } from 'models/enums';
import { type SearchArgType, type SearchResults } from 'types/api';
import { type KeywordSearchGeneralResult } from 'js-sdk/src/apis/SearchAPI';
import { Camelizer } from 'js-sdk/src/utils';

const SECONDS_TO_EXPIRE_CACHE = 2;

const keywordSearchPrimaryLevelApi = sdkApi.injectEndpoints({
  endpoints: (build) => ({
    search: build.query<SearchResults<KeywordSearchGeneralResult>, SearchArgType>({
      queryFn: async ({ searchValue, orgId, continuation }, _queryApi) => {
        const res = await TCClient.search.keywordSearch({
          organizationId: orgId,
          version: 'SEARCH_PARITY',
          types: [SearchTypes.MESSAGE],
          continuation: continuation || '',
          searchText: searchValue,
        });

        const results = res.results as KeywordSearchGeneralResult[];

        return {
          data: {
            results: results,
            metadata: Camelizer.camelizeObject(res.metadata),
          },
        };
      },
      serializeQueryArgs: ({ queryArgs }) => {
        const { searchValue, orgId } = queryArgs;
        return { searchValue, orgId };
      },
      merge: (currentCache, newItems) => {
        if (newItems.metadata.firstHit === 1) {
          currentCache.results = newItems.results;
          currentCache.metadata = newItems.metadata;
        } else {
          currentCache.results.push(...newItems.results);
          currentCache.metadata = newItems.metadata;
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return true;
      },
      keepUnusedDataFor: SECONDS_TO_EXPIRE_CACHE,
    }),
  }),
  overrideExisting: true,
});

export const { useSearchQuery } = keywordSearchPrimaryLevelApi;
